import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { formatterPx, batchFormatPx } from '@/utils';
import { pick } from 'lodash-es';

export default () => {
  const store = useStore();
  const appState = computed(() => store.state.app);
  const cropInfoTemp = computed(() => appState.value.cropInfoTemp);
  const cropChangeFlag = computed(() => cropInfoTemp.value.changeFlag);

  const isFixedRatio = computed(() => {
    const { ratioValue } = appState.value.cropInfoTemp;
    return typeof ratioValue === 'number';
  });
  const corners = computed(() =>
    isFixedRatio.value ? ['tl', 'tr', 'bl', 'br'] : ['tl', 'tc', 'tr', 'ml', 'mr', 'bl', 'bc', 'br']
  );
  const { backgroundColor } = appState.value;
  const { canvasWidth, canvasHeight } = appState.value.editorSize;
  const getOriginalCrop = () => ({ left: 0, top: 0, width: canvasWidth, height: canvasHeight });
  const getStoreCropInfo = () => pick(appState.value.cropInfoTemp, ['left', 'top', 'width', 'height']);
  const cropBoxUnZoomedPosition = ref(getStoreCropInfo());
  // console.log(1111111, { ...cropBoxUnZoomedPosition.value });
  const cropBoxStyle = computed(() => {
    const { left, top, width, height } = cropBoxUnZoomedPosition.value;
    const { canvasScale } = appState.value;
    const zoomLeft = canvasScale * left;
    const zoomTop = canvasScale * top;
    const zoomWidth = canvasScale * width;
    const zoomHeight = canvasScale * height;
    const result = {
      ...batchFormatPx({ left: zoomLeft, top: zoomTop, width: zoomWidth, height: zoomHeight }),
      backgroundImage: `url(${appState.value.OriginUrl})`,
      backgroundPosition: `${formatterPx(-zoomLeft)} ${formatterPx(-zoomTop)}`,
      backgroundSize: `${formatterPx(canvasWidth * canvasScale)} ${formatterPx(canvasHeight * canvasScale)}`,
      backgroundColor,
    };
    return result;
  });

  // 根据cropSetting中设置的裁剪信息，来设置裁剪框
  watch(
    cropChangeFlag,
    () => {
      const { cropInfoTemp } = appState.value;
      const { canvasWidth, canvasHeight } = appState.value.editorSize;
      const { ratioValue } = cropInfoTemp;
      console.log('crop', JSON.stringify(cropInfoTemp));
      const imageRatio = canvasWidth / canvasHeight;
      let cropBoxLeft = 0;
      let cropBoxTop = 0;
      let cropBoxWidth = 0;
      let cropBoxHeight = 0;
      const {
        left: originLeft,
        top: originTop,
        width: originWidth,
        height: originHeight,
      } = cropBoxUnZoomedPosition.value;
      const originCenter = { x: originLeft + originWidth / 2, y: originTop + originHeight / 2 };
      switch (ratioValue) {
        case 'original':
          cropBoxUnZoomedPosition.value = getOriginalCrop();
          break;
        case 'custom':
          break;
        default:
          // 视觉上的效果类似于background-size:contain
          if (ratioValue >= imageRatio) {
            cropBoxWidth = canvasWidth;
            cropBoxHeight = cropBoxWidth / ratioValue;
            cropBoxTop = 0;
          } else {
            cropBoxHeight = canvasHeight;
            cropBoxWidth = cropBoxHeight * ratioValue;
            cropBoxLeft = 0;
          }
          Object.assign(cropBoxUnZoomedPosition.value, {
            left: cropBoxLeft,
            top: cropBoxTop,
            width: cropBoxWidth,
            height: cropBoxHeight,
          });
          break;
      }
      // console.log(nv, cropBoxUnZoomedPosition.value);
    },
    { deep: true }
  );

  watch(
    cropBoxUnZoomedPosition,
    nv => {
      const cropInfoTemp = pick(nv, ['left', 'top', 'width', 'height']);
      store.commit('app/patchCropInfo', [cropInfoTemp, true]);
    },
    { deep: true }
  );

  // 拖动裁剪框
  let cropBoxDragging = false;
  let dragStartInfo = {};
  const onCropBoxMouseDown = e => {
    cropBoxDragging = true;
    const { left, top } = cropBoxUnZoomedPosition.value;
    const { canvasScale } = appState.value;
    // cropBoxx，cropBoxy记录的时候缩放之后的值（实际界面上的值）
    dragStartInfo = { x: e.pageX, y: e.pageY, cropBoxLeft: left * canvasScale, cropBoxTop: top * canvasScale };
    console.log('down', dragStartInfo);
  };
  const onCropBoxMouseMove = e => {
    if (!cropBoxDragging) return;
    const { canvasScale } = appState.value;
    const [diffX, diffY] = [e.pageX - dragStartInfo.x, e.pageY - dragStartInfo.y];
    const { cropBoxLeft, cropBoxTop } = dragStartInfo;
    const left = (cropBoxLeft + diffX) / canvasScale;
    const top = (cropBoxTop + diffY) / canvasScale;
    const { width, height } = cropBoxUnZoomedPosition.value;
    // 记录的是缩放为1的时候的值
    Object.assign(cropBoxUnZoomedPosition.value, {
      left: left < 0 ? 0 : left + width > canvasWidth ? canvasWidth - width : left,
      top: top < 0 ? 0 : top + height > canvasHeight ? canvasHeight - height : top,
    });
    // console.log('move', { diffX, diffY, aaa: cropBoxUnZoomedPosition.value });
  };
  const onCropBoxMouseUp = e => {
    // console.log('up');
    cropBoxDragging = false;
  };

  // 拖动触手
  let knobDragging = false;
  const knobDragStartInfo = {};
  const onKnobMouseDown = (e, knob) => {
    knobDragging = true;
    const { left, top, width, height } = cropBoxUnZoomedPosition.value;
    const { canvasScale } = appState.value;
    Object.assign(knobDragStartInfo, {
      knob,
      startX: e.pageX,
      startY: e.pageY,
      cropBoxLeft: left * canvasScale,
      cropBoxTop: top * canvasScale,
      cropBoxRight: (left + width) * canvasScale,
      cropBoxBottom: (top + height) * canvasScale,
      cropBoxWidth: width * canvasScale,
      cropBoxHeight: height * canvasScale,
    });
    console.log('knob down', knobDragStartInfo);
  };
  const onKnobMouseMove = e => {
    if (!knobDragging) return;
    const { ratioValue } = appState.value.cropInfoTemp;
    const { canvasScale } = appState.value;
    const { knob, startX, startY, cropBoxLeft, cropBoxTop, cropBoxRight, cropBoxBottom, cropBoxWidth, cropBoxHeight } =
      knobDragStartInfo;
    const [diffX, diffY] = [e.pageX - startX, e.pageY - startY];

    let left = cropBoxLeft + diffX;
    left = left < 0 ? 0 : left;
    let top = cropBoxTop + diffY;
    top = top < 0 ? 0 : top;
    const zoomLeft = left / canvasScale;
    const zoomTop = top / canvasScale;
    const result = {};

    const originCenter = {
      x: (cropBoxLeft + cropBoxWidth / 2) / canvasScale,
      y: (cropBoxTop + cropBoxHeight / 2) / canvasScale,
    };

    switch (knob) {
      case 'tl':
        result.left = (cropBoxRight - left) / canvasScale >= 10 ? zoomLeft : cropBoxRight / canvasScale - 10;
        result.width = cropBoxRight / canvasScale - result.left;
        if (isFixedRatio.value) {
          result.height = result.width / ratioValue;
          result.top = cropBoxBottom / canvasScale - result.height;
        } else {
          result.top = (cropBoxBottom - top) / canvasScale >= 10 ? zoomTop : cropBoxBottom / canvasScale - 10;
          result.height = cropBoxBottom / canvasScale - result.top;
        }
        break;
      case 'tc':
        result.top = (cropBoxBottom - top) / canvasScale >= 10 ? zoomTop : cropBoxBottom / canvasScale - 10;
        result.height = cropBoxBottom / canvasScale - result.top;
        break;
      case 'tr':
        result.width = (cropBoxWidth + diffX) / canvasScale;
        result.width = result.width + cropBoxLeft > canvasWidth ? canvasWidth - cropBoxLeft : result.width;
        if (isFixedRatio.value) {
          result.height = result.width / ratioValue;
          result.top = cropBoxBottom / canvasScale - result.height;
          result.top = cropBoxBottom / canvasScale - result.top <= 10 ? cropBoxBottom / canvasScale - 10 : result.top;
        } else {
          result.top = (cropBoxBottom - top) / canvasScale >= 10 ? zoomTop : cropBoxBottom / canvasScale - 10;
          result.height = cropBoxBottom / canvasScale - result.top;
        }
        break;
      case 'ml':
        result.left = (cropBoxRight - left) / canvasScale >= 10 ? zoomLeft : cropBoxRight / canvasScale - 10;
        result.width = cropBoxRight / canvasScale - result.left;
        break;
      case 'mr':
        result.width = (cropBoxWidth + diffX) / canvasScale;
        result.width = result.width + cropBoxLeft > canvasWidth ? canvasWidth - cropBoxLeft : result.width;
        result.width = result.width < 10 ? 10 : result.width;
        break;
      case 'bl':
        result.left = (cropBoxRight - left) / canvasScale >= 10 ? zoomLeft : cropBoxRight / canvasScale - 10;
        result.width = cropBoxRight / canvasScale - result.left;
        if (isFixedRatio.value) {
          result.height = result.width / ratioValue;
        } else {
          result.height = (cropBoxHeight + diffY) / canvasScale;
        }
        result.height = result.height + cropBoxTop > canvasHeight ? canvasHeight - cropBoxTop : result.height;
        break;
      case 'bc':
        result.height = (cropBoxHeight + diffY) / canvasScale;
        result.height = result.height + cropBoxTop > canvasHeight ? canvasHeight - cropBoxTop : result.height;
        result.height = result.height < 10 ? 10 : result.height;
        break;
      case 'br':
        result.width = (cropBoxWidth + diffX) / canvasScale;
        result.width = result.width + cropBoxLeft > canvasWidth ? canvasWidth - cropBoxLeft : result.width;
        if (isFixedRatio.value) {
          result.height = result.width / ratioValue;
        } else {
          result.height = (cropBoxHeight + diffY) / canvasScale;
        }
        result.height = result.height + cropBoxTop > canvasHeight ? canvasHeight - cropBoxTop : result.height;
        break;
    }

    Object.assign(cropBoxUnZoomedPosition.value, result);
  };

  const onKnobMouseUp = (e, type) => {
    knobDragging = false;
  };

  const onMouseUp = () => {
    onCropBoxMouseUp();
    onKnobMouseUp();
  };
  const onMouseMove = e => {
    if (knobDragging) {
      onKnobMouseMove(e);
    } else if (cropBoxDragging) {
      onCropBoxMouseMove(e);
    }
  };

  return {
    isFixedRatio,
    corners,
    cropBoxUnZoomedPosition,
    cropBoxStyle,
    onCropBoxMouseDown,
    onCropBoxMouseMove,
    onCropBoxMouseUp,
    onKnobMouseDown,
    onKnobMouseMove,
    onKnobMouseUp,
    onMouseUp,
    onMouseMove,
  };
};
